export default {
    IndexSynchronization: {
        Code: 'Code',
        Index: 'Index',
        Description: 'Description',
        New: 'New',
        type: 'Source type',
        Data: 'Data source',
        add: {
            Basic: 'Account Information',
            Data: 'Data source details',
            Whether: 'Whether to record to file',
            Command: 'Command text',
            field: 'Synchronization field',
            name: 'Field name',
            Mapping: 'Mapping field',
            Operation: 'Action',
            code: 'Please enter the code',
            index: 'Please enter the index',
            datasource: 'Please enter a data source',
            type: 'Please select a source type',
            obtain: 'Please enter the index to obtain mapping field information first!',
            information: 'Please enter the synchronization field information',
        }
    },
};
